// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import dayjs from 'dayjs';

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const MAX_DAYS_AHEAD = 7;

/**
 * "heute", "morgen", "in 3 Tagen" — or undefined outside the next week, where an absolute date
 * reads better. Compares local calendar days, so a timestamp late tonight is still "heute".
 */
export function getRelativeDayLabel(
    date: string | Date | undefined | null,
    now: Date = new Date(),
): string | undefined {
    if (!date) {
        return undefined;
    }

    const target = dayjs(date).toDate();
    if (Number.isNaN(target.getTime())) {
        return undefined;
    }

    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfTarget = new Date(target.getFullYear(), target.getMonth(), target.getDate());
    const daysAhead = Math.round((startOfTarget.getTime() - startOfToday.getTime()) / DAY_IN_MS);

    if (daysAhead < 0 || daysAhead > MAX_DAYS_AHEAD) {
        return undefined;
    }
    if (daysAhead === 0) {
        return 'heute';
    }
    if (daysAhead === 1) {
        return 'morgen';
    }
    return `in ${daysAhead} Tagen`;
}
